import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { LightBoxUILockHeader } from './lightbox_ui_lock_header';
import { LightBoxUILockContent } from './lightbox_ui_lock_content';

function LightBoxUILock(props) {
    return (
        <Lightbox
            opened={props.visible}
            onClose={props.onClose}
            additionalClassNames={['fs-remove-light-box__lightbox']}
        >
            <div className="fsf__app">
                <LightBoxUILockHeader loaded={props.loaded} />
                <LightBoxUILockContent loaded={props.loaded} />
            </div>
        </Lightbox>
    );
}

LightBoxUILock.propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { LightBoxUILock };
